import UserProfileStore from './UserProfileStore'

export default UserProfileStore
